import React from 'react';
import cn from 'bem-cn';

import { getAvatarSrc } from '../../contexts/UserContext/UserContext.helpers';

import { useGetUserScoreAndRankQuery } from '../../store/services/leaderboard';
import { AvatarWithRating, Icon, Popover, Stack } from '../../components/UI';
import { ProfileNestedRoutes, RoutePaths } from '../../constants';

import { ProfileProps } from './Profile.types';
import { useScrollToElement } from './Profile.hooks';

import './Profile.scss';

const b = cn('profile');

export const Profile: React.FC<ProfileProps> = ({
    isMy,
    loginOrPublicId,
    avatarSrc,
    firstName,
    lastName,
    fullName,
    isProfilePublic,
    onShareButtonMouseEnter,
    onShareButtonMouseLeave,
    onShareButtonClick,
}) => {
    const { data, isError, isLoading } = useGetUserScoreAndRankQuery({ loginOrPublicId });

    const { scrollToElement } = useScrollToElement({
        elementId: 'leaderboard-user-item',
        targetPath: isMy
            ? RoutePaths.ProfileRating
            : [RoutePaths.UserProfile, loginOrPublicId, ProfileNestedRoutes.Rating].join('/'),
    });

    return (
        <Stack spacing={16} className={b()} alignItems="center">
            <AvatarWithRating
                size="large"
                avatarSrc={avatarSrc || getAvatarSrc()}
                score={data?.score}
                rank={data?.rank !== undefined ? data.rank + 1 : undefined}
                isScoreLoading={isLoading}
                scoreError={isError || data?.is_user_exists === false}
            />
            <Stack spacing={12}>
                <Stack
                    spacing={6}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    className={b('toLeaderboard')}
                    onClick={scrollToElement}
                >
                    <span>В рейтинге:</span>
                    <Icon name="trophy" size={20} className="trophy" />
                    <span>{data?.rank !== undefined ? data.rank + 1 : '-'}</span>
                    <Icon name="chevronRight" size={16} className="chevron-right" />
                </Stack>
                <Stack spacing={8} direction="row" alignItems="center" justifyContent="center">
                    <span className={b('name')}>{fullName || `${firstName} ${lastName ? lastName.at(0) : ''}.`}</span>
                    <Popover position="top" content="Ссылка скопирована" disabled={!isProfilePublic}>
                        <button
                            className={b('share-button')}
                            onClick={onShareButtonClick}
                            onMouseEnter={onShareButtonMouseEnter}
                            onMouseLeave={onShareButtonMouseLeave}
                        >
                            <Icon name="share" size={20} fillColor="rgba(0, 0, 0, 0.9)" />
                        </button>
                    </Popover>
                </Stack>
            </Stack>
        </Stack>
    );
};
